
$( document ).ready(function() {
  var url='';
  var pathname = window.location.host;
  if (pathname == "115.113.146.196") {
    url = '/habitat';
  }
  
  
  var forumUrl = drupalSettings.un_habitat_tribe.tribe.community_url;
  var oathToken = sessionStorage.getItem("accesstoken");
  $('#community-user-id').click(function(){
    $.ajax({
      url: url + "/getUserById",
      type: 'GET',
      dataType: 'json',
      success: function (data) {    
        if (oathToken === null || oathToken === '') {
          getAccessToken(data);
        }else{
          createUser(data);
        }
      }
    });
  });

  function getAccessToken(userdata){    
    
    $.ajax({
      url: forumUrl + "/api/v1/oauth/token",
      type: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: {
        grant_type: drupalSettings.un_habitat_tribe.tribe.grant_type,
        client_id: drupalSettings.un_habitat_tribe.tribe.client_id,
        client_secret: drupalSettings.un_habitat_tribe.tribe.secret_key,
        email: userdata.email,
        //password: data.password
      },
      success: function (response) {            
        sessionStorage.setItem("accesstoken", response.access_token);
        createUser(userdata);
      }
    });
  }

  function createUser(userdata){
    var oathToken = sessionStorage.getItem("accesstoken");
    $.ajax({
      url: forumUrl + "/api/v1/users",
      type: 'POST',
      
      crossDomain: true,
      headers: {        
        "Access-Control-Allow-Origin": "*"
    },
      beforeSend: function (xhr) {
        xhr.setRequestHeader("Authorization", "Bearer "+oathToken );	  
      },
      data: {
        username: userdata.username,
        name: userdata.name,
        email: userdata.email,
        password: userdata.password 
      },      
      success: function (res) {
        console.log(res);
        if (res.code == "401") {
          getAccessToken(userdata);
        }else{ 
          var userId = res.id;
          assignToGroup(userId);
        }
      },
     
    });
  }

  function assignToGroup(id){
    var oathToken = sessionStorage.getItem("accesstoken");
    $.ajax({
      url: forumUrl + "/api/v1/groups/:"+id+"/members",
      type: 'POST',
      headers: {        
        "Access-Control-Allow-Origin": "*"
      },
      beforeSend: function (xhr) {
        xhr.setRequestHeader("Authorization", "Bearer "+oathToken );	  
      },
      data: {
        user: id 
      },      
      success: function (res) {        
        console.log(res);
        
        window.location.href = forumUrl + "/auth/sso?ssoToken="+oathToken+"&redirect=/answers";
      },
     
    });
  }
});

